(function () {
  'use strict';

  var header = document.getElementById('site-header');
  var megaScrim = document.getElementById('mega-scrim');
  var openMegaKey = null;
  var hoverTimer = null;
  var leaveTimer = null;

  function showMega(key) {
    if (!key) return;
    openMegaKey = key;
    document.querySelectorAll('.mega').forEach(function (m) {
      m.hidden = m.getAttribute('data-mega-panel') !== key;
    });
    document.querySelectorAll('.nav-trigger').forEach(function (t) {
      var matches = t.getAttribute('data-mega') === key;
      t.setAttribute('aria-expanded', matches ? 'true' : 'false');
      if (matches) t.classList.add('is-active');
      else t.classList.remove('is-active');
    });
    if (megaScrim) megaScrim.classList.add('is-on');
  }

  function closeMega(returnFocus) {
    if (!openMegaKey) return;
    var lastKey = openMegaKey;
    openMegaKey = null;
    document.querySelectorAll('.mega').forEach(function (m) { m.hidden = true; });
    document.querySelectorAll('.nav-trigger').forEach(function (t) {
      t.setAttribute('aria-expanded', 'false');
      t.classList.remove('is-active');
    });
    if (megaScrim) megaScrim.classList.remove('is-on');
    if (returnFocus) {
      var trig = document.querySelector('.nav-trigger[data-mega="' + lastKey + '"]');
      if (trig) trig.focus();
    }
  }

  function bindEvents() {
    var triggers = document.querySelectorAll('.nav-trigger');
    triggers.forEach(function (t) {
      var key = t.getAttribute('data-mega');
      t.addEventListener('click', function (e) {
        var href = (t.getAttribute('href') || '').trim();
        var isHash = !href || href === '#' || href === '#$' || href.indexOf('javascript:') === 0;
        if (isHash) {
          e.preventDefault();
          openMegaKey === key ? closeMega() : showMega(key);
        }
      });

      t.addEventListener('mouseenter', function () {
        clearTimeout(leaveTimer);
        clearTimeout(hoverTimer);
        hoverTimer = setTimeout(function () { showMega(key); }, openMegaKey ? 0 : 100);
      });
      t.addEventListener('mouseleave', function () { clearTimeout(hoverTimer); });
    });

    if (header) {
      header.addEventListener('mouseleave', function () {
        leaveTimer = setTimeout(closeMega, 220);
      });
      header.addEventListener('mouseenter', function () {
        clearTimeout(leaveTimer);
      });
    }

    if (megaScrim) {
      megaScrim.addEventListener('click', function () { closeMega(); });
      megaScrim.addEventListener('mouseenter', function () { closeMega(); });
    }

    document.querySelectorAll('.mega a').forEach(function (a) {
      a.addEventListener('click', function () { closeMega(); });
    });
  }

  bindEvents();

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector('#site-header') || e.target.id === 'site-header') {
      header = document.getElementById('site-header');
      megaScrim = document.getElementById('mega-scrim');
      bindEvents();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openMegaKey) {
      closeMega(true);
    }
  });

  window.TDCHeader = {
    open: showMega,
    close: closeMega
  };
})();